/*
 * @Author: 肖玲
 * @Date: 2023-07-05 10:05:04
 * @LastEditTime: 2023-07-06 10:34:16
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\jurisdiction-manage\dept-juris-manage\modules\futureFramework.js
 * 文件备注
 */
const futureFramework = [
  // 未来组织结构
  {
    path: '/jurisdictionSystem/future-organization/page',
    name: 'futureOrganization',
    component: () =>
      import(
        /*webpackChunkName:"areaOfResponsibility" */
        '@/views/jurisdiction-manage/dept-juris-manage/future-framework/future-organization/Page.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '未来组织架构',
    },
  },
  
  
  // 未来三者关系
  {
    path: '/jurisdictionSystem/future-relations/page',
    name: 'futureRelations',
    component: () =>
      import(
        /*webpackChunkName:"areaOfResponsibility" */
        '@/views/jurisdiction-manage/dept-juris-manage/future-framework/future-relations/Page.vue'
      ),
    meta: {
      SecondaryMenu: '辖区关系', //二级菜单
      title: '未来三者关系',
    },
  },
]

export default futureFramework